/**
 * Map Debug Utilities
 * -------------------
 * Lightweight debugging helpers for map layer diagnostics.
 * Enable verbose mode via window.__seaWatchDebug = true in the console.
 */

/** Check if debug mode is enabled */
export function isDebugEnabled(): boolean {
  return typeof window !== 'undefined' && (window as Window & { __seaWatchDebug?: boolean }).__seaWatchDebug === true;
}

/** Log a debug message (only when debug mode is enabled) */
export function debugLog(prefix: string, message: string, data?: unknown): void {
  if (!isDebugEnabled()) return;
  if (data !== undefined) {
    // eslint-disable-next-line no-console
    console.log(`[${prefix}] ${message}`, data);
  } else {
    // eslint-disable-next-line no-console
    console.log(`[${prefix}] ${message}`);
  }
}

/** Log a warning (always shown) */
export function warnLog(prefix: string, message: string, data?: unknown): void {
  if (data !== undefined) {
    console.warn(`[${prefix}] ${message}`, data);
  } else {
    console.warn(`[${prefix}] ${message}`);
  }
}

/** Log an error (always shown) */
export function errorLog(prefix: string, message: string, data?: unknown): void {
  if (data !== undefined) {
    console.error(`[${prefix}] ${message}`, data);
  } else {
    console.error(`[${prefix}] ${message}`);
  }
}

/**
 * Attach layer status summary to window for inspection.
 * Call this periodically or after major state changes.
 */
export function exposeLayerStatus(layerStatus: Record<string, { status: string; errorMessage?: string }>): void {
  if (typeof window === 'undefined') return;
  (window as Window & { __seaWatchLayerStatus?: typeof layerStatus }).__seaWatchLayerStatus = layerStatus;
}
